<template>
  <div>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {},
  created() {
    // sessionStorage.clear(); // 測試再打開

    const storedUser = sessionStorage.getItem("user");

    if (storedUser) {
      // console.log("get session user");
      this.$store.commit("SET_USER", JSON.parse(storedUser)); // Assuming you have a mutation named SET_USER
    } else {
      // console.log('create user');
      this.$store.dispatch("fetchUserData");
    }

  },
};
</script>